var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxIndeterminate = function SvgCheckboxIndeterminate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.778 0H2.222C1 0 0 1 0 2.222v15.556C0 19 1 20 2.222 20h15.556C19 20 20 19 20 17.778V2.222C20 1 19 0 17.778 0Zm-2.222 11.111H4.444V8.89h11.112v2.222Z",
    fill: "#E2E0DF"
  })));
};
export { SvgCheckboxIndeterminate as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3Ljc3NzggMEgyLjIyMjIyQzEgMCAwIDEgMCAyLjIyMjIyVjE3Ljc3NzhDMCAxOSAxIDIwIDIuMjIyMjIgMjBIMTcuNzc3OEMxOSAyMCAyMCAxOSAyMCAxNy43Nzc4VjIuMjIyMjJDMjAgMSAxOSAwIDE3Ljc3NzggMFpNMTUuNTU1NiAxMS4xMTExSDQuNDQ0NDRWOC44ODg4OUgxNS41NTU2VjExLjExMTFaIiBmaWxsPSIjRTJFMERGIi8+Cjwvc3ZnPgo=";